import { useEffect } from 'react';

import useTranslation from '../utils/useTranslation';

function formatDate(iso, lang) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString(lang === 'ar' ? 'ar-EG' : 'en-GB', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  } catch (_) {
    return '';
  }
}

export default function ArticleModal({ article, onClose }) {
  const { lang } = useTranslation();

  useEffect(() => {
    if (!article) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [article, onClose]);

  if (!article) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal modal-wrap"
        role="dialog"
        aria-modal="true"
        aria-label={article.title}
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="modal-close" onClick={onClose} aria-label="Close">
          {'\u00D7'}
        </button>
        {article.image_url && (
          <img className="modal-hero" src={article.image_url} alt={article.title} />
        )}
        <div className="modal-body">
          <h2 className="modal-title">{article.title}</h2>
          {article.uploaded_date && (
            <div className="modal-date">{formatDate(article.uploaded_date, lang)}</div>
          )}
          <div
            className="modal-content"
            // Content is sanitized server-side and authored by trusted staff.
            dangerouslySetInnerHTML={{ __html: article.content || '' }}
          />
        </div>
      </div>
    </div>
  );
}

export { formatDate };
